<script setup lang="ts">
import { ref } from 'vue'
import Box from '@uiKit/elements/Box.vue'
import TokenWalletSetup from './TokenWalletSetup.vue'
import TokenWalletActivate from './TokenWalletActivate.vue'
import TokenWalletEnableTrustline from './TokenWalletEnableTrustline.vue'
import TokenWalletPending from './TokenWalletPending.vue'
import TokenWalletBalance from './TokenWalletBalance.vue'

type WalletStep = 'setup' | 'activate' | 'trustline' | 'pending' | 'balance'

const emit = defineEmits<{
  (e: 'connect-wallet', address: string): void
  (e: 'enable-trustline'): void
  (e: 'view-all-transactions'): void
}>()

const step = ref<WalletStep>('setup')
const linkedAddress = ref('')
const submittedAt = ref('')

const onConnect = (address: string) => {
  linkedAddress.value = address
  step.value = 'activate'
  emit('connect-wallet', address)
}

const onCheckStatus = () => {
  step.value = 'trustline'
}

const onConfirmed = () => {
  step.value = 'balance'
}

const onEnable = () => {
  submittedAt.value = new Date().toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })
  step.value = 'pending'
  emit('enable-trustline')
}
</script>

<template>
  <Box direction="col" grow class="token-wallet-tab">
    <TokenWalletSetup v-if="step === 'setup'" @connect="onConnect" />
    <TokenWalletActivate
      v-else-if="step === 'activate'"
      :wallet-address="linkedAddress"
      @check-status="onCheckStatus"
    />
    <TokenWalletEnableTrustline
      v-else-if="step === 'trustline'"
      :wallet-address="linkedAddress"
      @enable="onEnable"
    />
    <TokenWalletPending
      v-else-if="step === 'pending'"
      :submitted-at="submittedAt"
      @confirmed="onConfirmed"
    />
    <TokenWalletBalance
      v-else-if="step === 'balance'"
      wallet-address="wallet-address-placeholder"
      @view-all-transactions="emit('view-all-transactions')"
    />
  </Box>
</template>

<style scoped>
.token-wallet-tab {
  /* layout via <Box direction="col" grow> */
}
</style>
